import React, { useState } from 'react'
import UserEditForm from '../../../../forms/User/Edit'
import { useParams, useHistory } from 'react-router-dom'
import Loader from '../../../../components/Loader'
import { Fetch, useAuth } from '@polvo-labs/react-auth'
import PageHeader from '../../PageHeader'
import PageContent from '../../PageContent'
import UpdateRole from '../../UpdateRole'
import { createGlobalStyle } from 'styled-components'
import Button from '../../../../components/Button'
import isAdmin from '../../../../utils/is-admin'
import routes from '../../../../config/routes'

const GlobalStyles = createGlobalStyle`
  .field-container:first-child {
    margin-bottom: 25px;
  }

  .field-container:not(:first-child) {
    position: relative;
    border: 1px solid #ececec;
    color: #7c8798;
    border-radius: 2px;
    margin-bottom: 25px;
    padding: 0;

    input,
    select {
      border: none;
      padding-left: 16px;
      font-size: 15px;
    }

    label {
      position: absolute;
      font-size: 11px;
      bottom: 100%;
      left: 10px;
      background-color: #fff;
      padding: 0 3px;
      color: #7c8798;
      font-weight: normal;
      transform: translateY(85%);
      z-index: 2;
    }

    .validation-error {
      bottom: -10px;
    }

    label + div {
      display: none;
    }
  }
`

const UserEditScreen: React.FC<{}> = () => {
  const { id } = useParams<{ id: string }>()
  const [key, setKey] = useState<number>(0)
  const { user } = useAuth()
  const history = useHistory()

  return (
    <div>
      <GlobalStyles />
      <Fetch
        key={key}
        url={`${process.env.REACT_APP_API_URL}/users/${id}`}
        loader={() => (
          <Loader
            darkMode
          />
        )}
      >
        {({ data }) => data && data.data && (
          <>
            <PageHeader
              title="Editar usuário"
              subtitle={`Editar usuário #${id}`}
              side={isAdmin(user) ? (<>
                <Button
                  label="Listar usuário"
                  backgroundColor="darkBlue"
                  fontColor="white"
                  borderColor="lightGray"
                  small
                  onClick={() => {
                    history.push(routes.admin.user.index.path)
                  }}
                />
              </>) : undefined}
            />
            <PageContent>
              <UserEditForm
                user={data.data}
              />
            </PageContent>
            <PageContent>
              <UpdateRole
                user={data.data}
                onChange={() => setKey(key => key + 1)}
              />
            </PageContent>
          </>
        )}
      </Fetch>
    </div>
  )
}

export default UserEditScreen
